import styled from "styled-components";

export const StyledScannerContainer = styled.div`
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    aspect-ratio: 1 / 1;
    background: ${({ theme }) => theme.colors.black};

    video {
        height: 100%;
        width: 100%;
    }
`;
